import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-stage border-y-4 border-gold py-12 text-center text-white" aria-label="Oferta por tiempo limitado" data-id="element-270" data-mp="2sk43xcq97k7c">
      <div className="mx-auto max-w-3xl px-4" data-id="element-271" data-mp="36bsg1g0i68ob">
        <p className="text-xs font-extrabold uppercase tracking-[.16em] text-gold" data-id="element-272" data-mp="31i6cqeg8bh56">Precio de lanzamiento · cierra en</p>
        <h2 className="mt-2 font-display text-2xl font-extrabold sm:text-3xl" data-id="element-273" data-mp="3g6kcggicmphi">Tu ciclo lectivo puede estar listo hoy</h2>
        <Countdown light className="mt-6 scale-110 shadow-lg" data-id="element-274" data-mp="3bb52hzngpdqd" />
        <p className="mt-7 font-bold text-mutedDark" data-id="element-275" data-mp="3p7s7mppkja7d">Después sube. No vuelve al precio de lanzamiento.</p>
        <div className="panel-dark mx-auto mt-6 max-w-xl rounded-xl border border-gold/40 p-4 text-sm" data-id="element-276" data-mp="3l8jftqe39meg">
          <p className="font-bold" data-id="element-277" data-mp="1uvatq8qmdmfe">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-gold" data-id="element-278" data-mp="1uwlus0sokg2t" />
            Cupos al precio de lanzamiento: quedan pocos
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-black/40" data-id="element-279" data-mp="2sv95nni0euef">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '71%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-gold" data-id="element-280" data-mp="2xtsqtlos425q" />
          </div>
          <p className="mt-1 text-right text-xs text-mutedDark" data-id="element-281" data-mp="3cgm0aabmadq0">71% tomados</p>
        </div>
      </div>
    </section>;
}